import { toast } from "react-toastify";
import { useGeneralAppStore } from "../store/generalAppStore";
import { toastOptions } from "../config/toast";
import { axios } from "../utils/axios";
import { isAxiosError } from "axios";

const { handlerLoading } = useGeneralAppStore.getState();

export const getPodadores = async () => {
  try {
    handlerLoading({ loading: true, loadName: "get_podadores" });
    const response = await axios().get("podadores_user");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "get_podadores" });
  }
};

export const getPodadoresPublic = async () => {
  try {
    handlerLoading({ loading: true, loadName: "podadores" });
    const response = await axios().get("lista_podadores");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "podadores" });
  }
};

export const asignarPodador = async (payload) => {
  try {
    handlerLoading({ loading: true, loadName: "asignar_podador" });
    const response = await axios().post("asignar_podador", payload);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      toast.success("Se agregaron los podadores a la solicitud correctamente", toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "asignar_podador" });
  }
};
